module.exports = __webpack_public_path__ + "img/lifecycle.00f2a70a.svg";